import React from "react"
import { StyleSheet } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import styled, { useTheme } from "~/ui/styled"
import { useSafeAreaInsets } from "~/ui/safe-area"
import { ColumnFlex, StartFlex, BetweenFlex, Button, Text, IconFont } from "~components/El"
import useNavigation from "~hooks/useNavigation"
import { useStores } from "~models"
import { Avatar } from "~widgets/avatar"
import { formatDate } from "~utils"

const Container = styled.ScrollView`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.blockBackground};
`
export const BlackList: React.FC = () => {
  const navigation = useNavigation()
  const theme = useTheme()
  const { blackListStore, userStore } = useStores()
  const currentUser = userStore?.currentUser
  const insets = useSafeAreaInsets()
  const data = []

  blackListStore.black_list.forEach((black) => {
    data.push(black)
  })
  const handleGoToPersonalCard = (user) => {
    navigation.push("PersonalCard", { userId: user.id })
  }

  return (
    <ColumnFlex flex={1} width="100%" padding="0 12px">
      <ColumnFlex
        flex={1}
        width="100%"
        padding="0 12px"
        mb="10px"
        borderRadius="8px"
        bg={theme.colors.blockBackground}
      >
        <ColumnFlex
            width="100%"
            padding="14px 0"
            borderBottomWidth={StyleSheet.hairlineWidth}
            borderBottomColor={theme.colors.border}
            borderBottomStyle="solid"
          >
            <Text color={theme.colors.text} fontSize={theme.fontSizes.md} fontWeight="600">已屏蔽用户（{blackListStore.black_list.size}）</Text>
            <Text color={theme.colors.secondary} fontSize={theme.fontSizes.sm} mt="3px">这些用户无法向您发送消息或添加您为好友</Text>
          </ColumnFlex>
        
        <Container style={{ paddingBottom: insets.bottom + 60 }}>
          {data.map((item) => (
            <BetweenFlex width="100%" padding="10px 0" key={item.id}>
              <StartFlex>
                <Avatar avatar={item.user?.avatar} name={item.user?.name} onClick={() => handleGoToPersonalCard(item.user)} />
                <ColumnFlex ml="10px">
                  <Text fontSize={theme.fontSizes.md} color={theme.colors.text} fontWeight="600">{item.user?.name}</Text>
                  {item.created && (
                    <Text fontSize={theme.fontSizes.sm} color={theme.colors.secondary} mt="2px">屏蔽时间：{formatDate(item.created)}</Text>
                  )}   
                </ColumnFlex>
              </StartFlex>
              <Button
                padding="10px 0"
                onClick={() => {
                  blackListStore.removeBlacklist(item.user_id)
                  blackListStore.queryBlacklistList(currentUser?.id)
                }}
              >
                <IconFont name="delete" size={18} color={theme.colors.error} />
              </Button>
            </BetweenFlex>
          ))}
        </Container>
      </ColumnFlex>
    </ColumnFlex>

  )
}

export default observer(BlackList)
